import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { SocialProof } from "@/components/SocialProof";
import { VideoSection } from "@/components/VideoSection";
import { HowItWorks } from "@/components/HowItWorks";
import { InteractiveDemo } from "@/components/InteractiveDemo";
import { Testimonials } from "@/components/Testimonials";
import { UseCases } from "@/components/UseCases";
import { Features } from "@/components/Features";
import { FAQ, faqData } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { SEO, seoConfig } from "@/hooks/useSEO";
import { organizationSchema, generateFAQSchema, softwareApplicationSchema } from "@/lib/jsonld";

/**
 * Page d'accueil UNOTIF - Landing Page Marketing
 */

const Index = () => {
  // Aplatir les FAQ pour le schema JSON-LD
  const allFaqItems = faqData.flatMap(cat => 
    cat.items.map(item => ({ question: item.question, answer: item.answer }))
  );

  const jsonLdSchemas = [
    organizationSchema,
    softwareApplicationSchema,
    generateFAQSchema(allFaqItems)
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEO {...seoConfig.home} jsonLd={jsonLdSchemas} />
      <Header />
      <main>
        <Hero />
        <SocialProof />
        <VideoSection />
        <HowItWorks />
        <InteractiveDemo />
        <Testimonials />
        <UseCases />
        <Features />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
